<template>
  <a :href="route('customer.dashboard', {
    customer: customerId,
  })">
    <div class="customer">
      <div v-if="customer && !loading" class="flex-row align-items-center justify-content-end gap-sm">
        <span class="font-size-sm wrap">{{ customer.initials + ' ' + customer.last_name }}</span>
        <CustomerAvatar :customer-id="customerId" size="small"></CustomerAvatar>
      </div>
      <div class="skeleton justify-content-end" v-if="loading">
        <span class="text animate-pulse">.</span>
        <span class="avatar animate-pulse">.</span>
      </div>
    </div>
  </a>
</template>

<script>
import customerApi from '~/api/customer';

export default {
  name: "Customer",
  props: {
    customerId: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      loading: false,
      customer: null,
    }
  },
  mounted() {
    this.loading = true;
    customerApi.findById(this.customerId).then((res) => {
      this.customer = res.data;
      this.loading = false;
    });
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.skeleton {
  color: white;
  display: flex;
  width: 150px;
  gap: $spacing-sm;
  align-items: center;
  .avatar {
    height: 24px;
    width: 24px;
    aspect-ratio: 1/1;
    border-radius: 9999px;
    background-color: white;
  }

  .text {
    border-radius: $border-radius-small;
    background-color: white;
    width: 100%;
    height: 16px;
  }
}

.customer {
  width: 150px;
}

.wrap {


  word-wrap: break-word

}
</style>
